// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y3u9w","toggle":"styles_toggle__2DMVK","preview":"styles_preview__1GeJ8"};